import { render, staticRenderFns } from "./pricelist.vue?vue&type=template&id=7f7b6faa&"
import script from "./pricelist.vue?vue&type=script&lang=js&"
export * from "./pricelist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f7b6faa')) {
      api.createRecord('7f7b6faa', component.options)
    } else {
      api.reload('7f7b6faa', component.options)
    }
    module.hot.accept("./pricelist.vue?vue&type=template&id=7f7b6faa&", function () {
      api.rerender('7f7b6faa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4eLUplb2NmATq/JS/comp/pricelist.vue"
export default component.exports